import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { getAuthState } from "@redriver/cinnamon";
import { AzureSsoSignIn } from "features/System";
import { AppRoutes } from "constants/routes";
import { SystemPageContent } from "components/pages";

const PKCE_VERIFIER_STORAGE_KEY = "microsoft_pkce_verifier";

const AzureSsoSignInPage = ({ loggedIn, location }) => {
  // query-string returns an array instead of a string if a key is repeated
  // in the query string - guard against that here so a non-string can't
  // reach the SSO API call or <Redirect to=/> below
  const parsed = queryString.parse(location.search);
  const code = typeof parsed.code === "string" ? parsed.code : null;
  const nextPathParam = typeof parsed.state === "string" ? parsed.state : null;

  // captured once on mount so a re-render can't observe it after it's cleared
  const [codeVerifier] = useState(() =>
    sessionStorage.getItem(PKCE_VERIFIER_STORAGE_KEY)
  );
  useEffect(() => {
    sessionStorage.removeItem(PKCE_VERIFIER_STORAGE_KEY);
  }, []);

  // no emailVerified/useEmailVerification gate here (unlike LoginPage) - if
  // a session is already active (e.g. back button after a completed SSO
  // sign-in, or a stale reload of this URL) just send them on their way
  if (loggedIn) {
    const nextRoute =
      nextPathParam &&
      nextPathParam.startsWith("/") &&
      !nextPathParam.startsWith("//")
        ? nextPathParam
        : AppRoutes.Root;
    return <Redirect to={nextRoute} />;
  }

  return (
    <SystemPageContent title="Signing you in...">
      <AzureSsoSignIn code={code} codeVerifier={codeVerifier} />
    </SystemPageContent>
  );
};

const mapStateToProps = (state) => {
  const { loggedIn } = getAuthState(state);
  return { loggedIn };
};

export default connect(mapStateToProps)(AzureSsoSignInPage);
